import Container from 'components/container';
import KeywordTable from 'components/keywords/keywordtable';
import Layout from 'components/layout';
import SearchResults from 'components/search/searchresults';
import Tabs from 'components/tabs';
import Anchor from 'components/typography/anchor';
import config from 'siteconfig';

import { POSTHOG_SIGNUP_EVENT_SMS } from 'utilities/analytics';

import {
  account,
  allCommands,
  community,
  educate,
  speak,
  targets,
  volunteer,
  vote,
} from 'utilities/commands';

const suggestedKeywords = allCommands.filter((keyword) => keyword.suggested);

const containers = [
  <Container key="speak">
    <KeywordTable
      commands={speak}
      description="Use these keywords to lobby your&nbsp;officials."
      section="speak"
      title="Lobby Your Officials"
    />
  </Container>,

  <Container key="targets">
    <KeywordTable
      commands={targets}
      description="When prompted for where to send your letter, reply with one of&nbsp;these."
      section="targets"
      title="Letter Targets"
    />
  </Container>,

  <Container key="vote">
    <KeywordTable
      commands={vote}
      description="Voting is your sacred civic duty, make sure you’re ready."
      section="vote"
      title="Get Ready to Vote"
    />
  </Container>,

  <Container key="volunteer">
    <KeywordTable
      commands={volunteer}
      description="Ten people taking action is better than you taking ten actions. Organize others for more&nbsp;impact."
      section="volunteer"
      title="Organize & Volunteer"
    />
  </Container>,

  <Container key="educate">
    <KeywordTable
      commands={educate}
      description="Informational keywords for issues, news, and&nbsp;data."
      section="learn"
      title="News, Issues, and Numbers"
    />
  </Container>,

  <Container key="community">
    <KeywordTable
      commands={community}
      description="Non-political community&nbsp;resources."
      section="community"
      title="Community Resources"
    />
  </Container>,

  <Container key="account">
    <KeywordTable
      commands={account}
      description="Bot settings and&nbsp;preferences."
      section="account"
      title="Manage your Account"
    />
  </Container>,
];

const Guide = () => {
  return (
    <Layout
      title="Resistbot Usage Guide"
      description="Bookmark or print this comprehensive guide to Resistbot keywords."
    >
      <section className="mx-auto max-w-prose">
        <h1>Keyword Guide</h1>
        <p className="mb-4">
          Resistbot responds to simple keywords, tap one to get started, or text
          one to{' '}
          <Anchor
            className="anchor-text"
            href={config.channelUrls.sms}
            eventName={POSTHOG_SIGNUP_EVENT_SMS}
          >
            50409
          </Anchor>
          .
        </p>
      </section>

      <Tabs
        descriptor="keyword groups"
        renderSearch={(searchText) => (
          <SearchResults
            keywords={allCommands}
            searchText={searchText}
            suggestedKeywords={suggestedKeywords}
          />
        )}
        sections={[
          {
            contents: containers,
            title: 'All',
          },
          {
            contents: containers[0],
            title: 'Speak',
          },
          {
            contents: containers[1],
            title: 'Targets',
          },
          {
            contents: containers[2],
            title: 'Vote',
          },
          {
            contents: containers[3],
            title: 'Volunteer',
          },
          {
            contents: containers[4],
            title: 'Learn',
          },
          {
            contents: containers[5],
            title: 'Community',
          },
          {
            contents: containers[6],
            title: 'Account',
          },
        ]}
      />
    </Layout>
  );
};

export default Guide;
